<lib-my-custom-pages></lib-my-custom-pages>

<h1 class="text-center m-5" [innerHTML]="'SELECT_CATEGORY' | translate"></h1>

<div class="row">
  <div class="col-12 col-md-6 col-xl-4" *ngFor="let subAssortment of subAssortments">
    <a routerLink="/categories/{{ subAssortment.id }}" class="category-container" style="min-height: 150px">
      <div class="category-label">
        {{ subAssortment.name }}
      </div>

      <div class="overlay"></div>
    </a>
  </div>
</div>
<div class="row">
  <div class="col-12 d-flex justify-content-center">
    <div class="spacer"></div>
  </div>
</div>

<div class="row mb-5">
  <div class="col-12 mb-4">
    <div class="extra-text-header">Lorem ipsum dolor sit amet</div>
  </div>
  <div class="col-12">
    <div class="extra-text">
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
      magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
      consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
      Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
    </div>
  </div>
</div>
